import { render, staticRenderFns } from "./PanelCompetitionSettingConfirmation.vue?vue&type=template&id=46c879ea&scoped=true&"
import script from "./PanelCompetitionSettingConfirmation.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionSettingConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionSettingConfirmation.vue?vue&type=style&index=0&id=46c879ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c879ea",
  null
  
)

export default component.exports